module.exports = __webpack_public_path__ + "img/Retailing.9339d608.png";